import "./Philosophy.module.css";
import Header from "@/reusable_sections/Header";
import Symmetry from "./sections/Symmetry";
import Prevention from "./sections/Prevention";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function PhilosophyPage() {
  return <div>
      <Header />
      <Symmetry />
      <Prevention />
      <Faq />
      <Footer />
    </div>;
}